import { render } from "./TraineeReports.vue?vue&type=template&id=659b2806&scoped=true"
import script from "./TraineeReports.vue?vue&type=script&lang=js"
export * from "./TraineeReports.vue?vue&type=script&lang=js"

import "./TraineeReports.vue?vue&type=style&index=0&id=659b2806&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659b2806"]])

export default __exports__